"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserFromToken = void 0;
function isUserFromToken(value) {
    var hasEmail = !!(value === null || value === void 0 ? void 0 : value.email);
    var hasId = !!(value === null || value === void 0 ? void 0 : value._id);
    return hasEmail && hasId;
}
exports.isUserFromToken = isUserFromToken;
//# sourceMappingURL=is-user-from-token.js.map